import React from 'react'
import { Button } from 'antd'

import './Button.scss'

const Btn = props => {
  const { className, block, primary, shape, style, size, label } = props
  return (
    <Button
      primary={primary}
      block={block}
      size={size}
      shape={shape}
      style={style}
      className={className}
      htmlType="submit"
      {...props}
    >
      {label || 'Button'}
    </Button>
  )
}

export default Btn
